export default "__VITE_ASSET__CBsE7txK__"